import React from "react";

import { useImmerReducer } from "use-immer";

import Movie from "./MovieObject";
import { defaultMovie } from "./MovieObject";

export const MovieContext = React.createContext(null);
export const MovieDispatch = React.createContext(null);

export function MovieProvider({ children }) {

    const [movie, dispatch] = useImmerReducer(movieReducer, new Movie(defaultMovie));

    return (
        <MovieContext.Provider value={movie}>
            <MovieDispatch.Provider value={dispatch}>
                {children}
            </MovieDispatch.Provider>
        </MovieContext.Provider>
    );
}

export function useMovie() {
    return React.useContext(MovieContext);
}
  
export function useMovieSetter() {
    return React.useContext(MovieDispatch);
}

function movieReducer(movieInstance, action) {
    switch (action.type) {
        case "updateMovie": {
            return movieInstance.updateMovie(action.movie);
        }
        case "updateScenes": {
            return movieInstance.updateScenes(action.scenes);
        }
        case "updateProperties": {
            return movieInstance.updateProperties(action.itemId, action.properties, action.field);
        }
        case "updateMovieProperty": {
            return movieInstance.updateMovieProperty(action.property, action.value);
        }
        case "selectItemById": {
            return movieInstance.selectItemById(action.itemId);
        }
        case "selectItemByCoords": {
            return movieInstance.selectItemByCoords(action.sceneIndex, action.elementIndex);
        }
        case "deleteItemById": {
            return movieInstance.deleteItemById(action.itemId);
        }
        case "deleteItemByCoords": {
            return movieInstance.deleteItemByCoords(action.sceneIndex, action.elementIndex);
        }
        case "duplicateItemById": {
            return movieInstance.duplicateItemById(action.itemId);
        }
        case "duplicateItemByCoords": {
            return movieInstance.duplicateItemByCoords(action.sceneIndex, action.elementIndex);
        }
        case "replaceItemById": {
            return movieInstance.replaceItemById(action.itemId, action.item);
        }
        default:
            console.log("action unknown", action);
            return movieInstance;
    }
}



